import { Flex, Image, Stack, Text } from "@mantine/core";
import { SimulationCard } from "./Simulations";
import { Carousel } from "@mantine/carousel";
import { useRef, useState } from "react";
import { useMediaQuery } from "@mantine/hooks";

type EmblaApi = {
  canScrollNext: () => boolean;
  canScrollPrev: () => boolean;
  scrollNext: (jump?: boolean) => void;
  scrollPrev: (jump?: boolean) => void;
};

export const ChapterSection = (props: {
  name: string;
  chapterId: string;
  selectedKey: string;
  simulationCategory: number;
  simulations: SimulationData[];
  onNextCrouselClick: (subject: string) => void;
  onClickChapterFilter: (chapter: string, chapterId: string) => void;
  setShowAuthModal: (val: boolean) => void;
  setSimualtionId: (val: string) => void;
  setPlaySimulation: (val: SimulationData) => void;
  paramValue: string | null;
  userSubscriptionType: string;
  setModalSimulation: (val: any) => void;
}) => {
  const carouselRef = useRef<any>(null);
  const [embla, setEmbla] = useState<EmblaApi | null>(null);
  const isMd = useMediaQuery(`(max-width: 900px)`);
  const [canStepBack, setCanStepBack] = useState<boolean>(false);
  const [canStepNext, setCanStepNext] = useState<boolean>(true);
  const handleNext = (subject: string) => {
    if (embla) {
      if (!embla.canScrollNext()) {
        setCanStepNext(false);
      } else {
        embla.scrollNext();
        props.onNextCrouselClick(subject);
        setCanStepBack(true);
      }
    }
  };

  const handlePrev = () => {
    if (embla) {
      embla.scrollPrev();
      if (!embla.canScrollPrev()) {
        setCanStepBack(false);
      } else {
        embla.scrollPrev();
        setCanStepNext(true);
      }
    }
  };

  return (
    <>
      <Stack w={"100%"} m={"auto"} h={"100%"}>
        <Flex
          w={isMd ? "100%" : "98%"}
          mx={"auto"}
          align={"center"}
          justify={"space-between"}
          onClick={()=>{
            props.onClickChapterFilter(
              props.name,
              props.chapterId
            )
          }}
          sx={{ cursor: "pointer" }}
        >
          <Flex pl={isMd ? "0.3rem" : ""} w={"85%"} align={"center"} gap={5}>
            <Text ff={"Nunito"} fw={700} sx={{whiteSpace:"pre-wrap"}} fz={isMd ? "16px" : "20px"}>
              {props.name}
            </Text>
            {!props.name.startsWith("Our") && (
              <Image
                onClick={() =>
                  props.onClickChapterFilter(
                    props.name,
                    props.chapterId
                  )
                }
                src={require("../../assets/simulationFilter.png")}
                ml={isMd?3:10}
                width={"20px"}
                sx={{ cursor: "pointer" }}
              />
            )}
          </Flex>
          <Flex align={"center"} gap={isMd?10:20} pr={isMd ? "0.5rem" : "2rem"}>
            {canStepBack ? (
              <Image
                src={require("../../assets/back-simulation-d.png")}
                width={isMd?"25px":"32px"}
                onClick={handlePrev}
                style={{ cursor: "pointer" }}
              />
            ) : (
              <Image
                src={require("../../assets/back-simulation.png")}
                width={isMd?"25px":"32px"}
                onClick={handlePrev}
                style={{ cursor: "pointer" }}
              />
            )}

            {canStepNext ? (
              <Image
                src={require("../../assets/next-simulation.png")}
                width={isMd?"25px":"32px"}
                onClick={() => handleNext(props.chapterId)}
                style={{ cursor: "pointer" }}
              />
            ) : (
              <Image
                src={require("../../assets/next-simulation-d.png")}
                width={isMd?"25px":"32px"}
                onClick={() => handleNext(props.chapterId)}
                style={{ cursor: "pointer" }}
              />
            )}
          </Flex>
        </Flex>
        <Flex w={"100%"} h={"100%"} sx={{ overflowX: "hidden" }}>
          <Carousel
            ref={carouselRef}
            height={"100%"}
            w={"100%"}
            getEmblaApi={(e: any) => setEmbla(e)}
            slideSize={isMd ? "200px" : "400px"}
            slideGap={"sm"}
            align="start"
            slidesToScroll={isMd ? 1 : 3}
            withControls={false}
            styles={{
              slide: {
                padding: 0,
                margin: 0,
              },
            }}
          >
            {props.simulations &&
              props.simulations.map((x, i) => (
                <Carousel.Slide key={x._id}>
                  <Stack h={"100%"}>
                    <SimulationCard
                      _id={x._id}
                      name={x.name}
                      isthreejs={x.isthreejs}
                      lgNo={4}
                      imageUrl={x.thumbnailImageUrl}
                      simulationType={x.simulationType}
                      setSimualtionId={(val: string) => {
                        props.setSimualtionId(val);
                      }}
                      setPlaySimulation={() => {
                        props.setPlaySimulation(x);
                      }}
                      simulationTags={x.simulationTags}
                      paramValue={props.paramValue}
                      userSubscriptionType={props.userSubscriptionType}
                      isSimulationPremium={x.isSimulationPremium}
                      setModalSimulation={(x: any) => {
                        props.setModalSimulation(x);
                      }}
                      videoUrl={x.videoUrl}
                      showInfo={true}
                      simulation={x}
                    />
                  </Stack>
                </Carousel.Slide>
              ))}
          </Carousel>
        </Flex>
      </Stack>
    </>
  );
};
